import { EventMessage } from '@/common/analytics/gtm/types';
import { AthenaClickEvent } from '@/common/hooks/useAthena/athenaEvents';

import { createArtworkEventContext } from './contexts';
import { searchTrackingStorageManager } from './utils';

export const trackAthenaAddToWishlist = (
  eventMessage: EventMessage,
  pushEvent: (event: AthenaClickEvent) => void,
) => {
  if (eventMessage.metadata.messageSendingDisabled) return;

  pushEvent({
    eventName: 'addToWishlist',
    eventType: 'click',
    eventParams: createAddToWishlistEventParams(eventMessage),
    context: createArtworkEventContext(eventMessage),
  });
};

const createAddToWishlistEventParams = (eventMessage: EventMessage) => {
  const {
    message: { externalId, internalId, name },
  } = eventMessage;

  const {
    searchQueryId = null,
    searchPosition = null,
    sort = null,
  } = searchTrackingStorageManager.getItem() || {};

  return {
    itemId: internalId,
    itemCollectionId: externalId,
    name: name || '',
    searchQueryId,
    searchPosition,
    sort,
  };
};
